/**
 * Copyright ©2025 Drivepoint
 */

// THIS FILE COULD BE SPLIT INTO MULTIPLE FILES TO MAKE IT MORE READABLE

import type {ErrorContext} from "./DPError";

type RANGES_ERRORS_CODES = "RANGES_TAB_NOT_FOUND" | "RANGES_NOT_FOUND_TAB" | "RANGES_SELECTED_TABS_NOT_CONFIGURED";
type ROLL_FORWARD_ERRORS_CODES = "ROLL_FORWARD_FAILED";

const RANGES_ERROR_DEFINITIONS: Record<RANGES_ERRORS_CODES, (ctx?: ErrorContext) => string> = {
  "RANGES_TAB_NOT_FOUND": () => "We could not find the 'Ranges' tab",
  "RANGES_SELECTED_TABS_NOT_CONFIGURED": () => "The selected tab(s) don't have corresponding data in the 'Ranges'",
  "RANGES_NOT_FOUND_TAB": (ctx: ErrorContext) => `We could not find '${ctx.tab}' tab that you indicated in the 'Ranges' tab`
};

const ROLL_FORWARD_ERROR_DEFINITIONS: Record<ROLL_FORWARD_ERRORS_CODES, (ctx?: ErrorContext) => string> = {
  "ROLL_FORWARD_FAILED": () => "None of the selected tabs were updated"
};

export type DP_ERRORS_CODES = RANGES_ERRORS_CODES | ROLL_FORWARD_ERRORS_CODES;

export const ERROR_DEFINITIONS: Record<DP_ERRORS_CODES, (ctx?: ErrorContext) => string> = {
  ...RANGES_ERROR_DEFINITIONS,
  ...ROLL_FORWARD_ERROR_DEFINITIONS
};
